/* Bazaarvoice rating gate.
   Hides inline star ratings (collection/search cards, PDP buy box) only
   when a product is BOTH under the minimum average (4.0) AND under the
   minimum review count (settings.bv_min_reviews, default 5). A low
   average with enough reviews still shows; so does a high average with
   few reviews.
   Bazaarvoice does not expose the review count server-side, so the count
   is read from what it renders into OUR mounts ([data-bv-show="inline_rating"]
   and [data-bv-show="rating_summary"]); the vendor DOM is never modified,
   only a class on the mount we own. The full reviews widget
   ([data-bv-show="reviews"]) is untouched so shoppers can still write
   reviews. Loaded once, deferred, from layout/theme.liquid. */
(function () {
  if (window.bvRatingGateInit) return;
  window.bvRatingGateInit = true;

  var GATED_CLASS = 'bv-rating-gated';
  var MOUNTS = '[data-bv-show="inline_rating"], [data-bv-show="rating_summary"]';
  var COUNT_SEL = '.bv_numReviews_text, .bv_numReviews_component_container';
  var RATING_SEL = '.bv_avgRating_component_container, .bv_averageRating_component_container, .bv_avgRating';
  var MIN_RATING = 4;

  function minReviews() {
    var configured = window.theme && window.theme.bvMinReviews;
    var min = parseInt(configured, 10);
    return isNaN(min) ? 5 : min;
  }

  /* Returns the rendered review count, 0 for Bazaarvoice's explicit
     zero-review states, or null while nothing usable has rendered yet. */
  function parseCount(mount) {
    var container = mount.querySelector('.bv_main_container');
    if (!container) return null;

    if (container.classList.contains('bv_hide_visibility')) return 0;
    if (container.children.length === 1 && container.firstElementChild.tagName === 'STYLE') return 0;

    var countEl = mount.querySelector(COUNT_SEL);
    var text = (countEl ? countEl.textContent : container.textContent) || '';
    var match = /(\d[\d,.]*)/.exec(text);
    if (match) return parseInt(match[1].replace(/[^\d]/g, ''), 10);
    if (/review/i.test(text)) return 0;
    return null;
  }

  /* Average rating Bazaarvoice rendered (e.g. "4.8"), 0 when there are no
     reviews, or null if it cannot be read. An unreadable average never
     gates on its own: only a confirmed low average does. */
  function parseRating(mount, count) {
    if (count === 0) return 0;
    var el = mount.querySelector(RATING_SEL);
    var text = el ? el.textContent : '';
    var match = /(\d+(?:[.,]\d+)?)/.exec(text || '');
    if (!match) {
      var label = mount.querySelector('[aria-label*="out of 5"], [aria-label*="of 5"]');
      if (label) match = /(\d+(?:[.,]\d+)?)/.exec(label.getAttribute('aria-label'));
    }
    if (!match) return null;
    var rating = parseFloat(match[1].replace(',', '.'));
    return rating >= 0 && rating <= 5 ? rating : null;
  }

  function settle(mount) {
    var count = parseCount(mount);
    if (count === null) return false;
    var rating = parseRating(mount, count);
    var fewReviews = count < minReviews();
    var lowRating = rating !== null && rating < MIN_RATING;
    mount.classList.toggle(GATED_CLASS, fewReviews && lowRating);
    return true;
  }

  function watch(mount) {
    if (mount.getAttribute('data-bv-gate-watched')) return;
    mount.setAttribute('data-bv-gate-watched', '1');
    if (settle(mount)) return;
    var observer = new MutationObserver(function () {
      if (settle(mount)) observer.disconnect();
    });
    observer.observe(mount, { childList: true, subtree: true, characterData: true });
  }

  function watchAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(MOUNTS).forEach(watch);
  }

  watchAll(document);

  /* Mounts that arrive later: quick view, facets re-render, section reload. */
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(MOUNTS)) {
          watch(node);
        } else if (node.querySelectorAll) {
          watchAll(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
